<template>
  <ConfigProvider :locale="getAntdLocale">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import { watch, ref, onBeforeUnmount, nextTick } from 'vue';
  import { ConfigProvider } from 'ant-design-vue';
  import { AppProvider } from '/@/components/Application';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';
  // support Multi-language
  const { getAntdLocale } = useLocale();
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  import { useLocaleStoreWithOut } from '/@/store/modules/locale';
  // dayjs locale is synced in useLocale().changeLocale()
  const localeStore = useLocaleStoreWithOut();
  dayjs.locale(localeStore.getLocale === 'en' ? 'en' : 'zh-cn');
  useTitle();
  import { useRoute } from 'vue-router';
  import { emitter, useStompClient, WS_EVENTS } from '/@/utils/wx/tkSetupStomp';
  import { useEventInfoStore } from '/@/store/modules/eventInfo';
  import { useUserStore } from '/@/store/modules/user';
  import { isEmpty } from '/@/utils/is';
  const stompClient = useStompClient();
  const eventInfoStore = useEventInfoStore();
  const userStore = useUserStore();
  const subscribeFn = (id: any) => {
    if (id && stompClient) {
      stompClient.subscribe(`/topic/l4nbSxx4.eventInfos.${id}`, (resData) => {
        if (!isEmpty(resData)) {
          eventInfoStore.setEventInfo(resData);
        }
      });
    }
  };
  const route = useRoute();
  const previousRoute = ref<string>('');
  watch(
    route,
    async (val) => {
      const organizationId = userStore.getUserInfo
        ? userStore.getUserInfo.organizationId
        : undefined;
      if (
        (!previousRoute.value && val.path && val.path !== '/login') ||
        previousRoute.value === '/login'
      ) {
        await nextTick();
        subscribeFn(organizationId);
      }
      previousRoute.value = val.path;
    },
    { immediate: true, flush: 'post' },
  );
  emitter.on(WS_EVENTS.RECONNECT, () => subscribeFn(userStore.getUserInfo.organizationId));
  onBeforeUnmount(() => {
    emitter.off(WS_EVENTS.RECONNECT, () => {});
  });
</script>
